<template>
  <vb-checkbox
    @change="handle_change"
    :vb_options="{
      text: 'Solo voli diretti',
      value:
        max_number_of_connections === '0' || max_number_of_connections === 0,
      checked:
        max_number_of_connections === '0' || max_number_of_connections === 0,
      type: 'light',
      switch: is_switch,
    }"
  />
</template>

<script>
import { set_direct_flight_filter_active } from "../../../utilities/filters";

export default {
  name: "search-by-connections",
  props: {
    is_switch: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    document.body.classList.remove("overflow-hidden");
  },
  computed: {
    max_number_of_connections: {
      get() {
        return this.$store.state.liveflight.max_number_of_connections !==
          undefined
          ? this.$store.state.liveflight.max_number_of_connections
          : 0;
      },
      set(value) {
        this.$store.commit("liveflight/max_number_of_connections", value);
      },
    },
  },
  methods: {
    set_direct_flight_filter_active,
    handle_change(selected) {
      // When checked, direct flights only (0 connections), when unchecked, allow up to 2 connections
      this.set_direct_flight_filter_active(selected);
      this.scroll_top();
    },
  },
};
</script>
